'use strict';

/**
 * Sends stlCarouselViewed event when Shop the Look carousel is 50% or more visible
 * @param {string} stlAnchorItemId - ID of the anchor product in carousel
 */
function pushStlCarouselViewedEvent() {
    var stlAnchorItemId = $('.product-detail').data('pid');
    if (stlAnchorItemId === $('#masterProductIDValue').val()) {
        stlAnchorItemId = $('.shop-the-look__product-tile').first().data('anchor-item-id');
    }
    var eventData = {
        event: 'stlCarouselViewed',
        stlAnchorItemId: stlAnchorItemId + ''
    };

    window.dataLayer.push(eventData);
}

/**
 * Sends stlCarouselClicked event when user clicks on a Shop the Look item
 * @param {number} carouselPositionSelected - Position of clicked item in carousel
 * @param {string} stlItemIdSelected - ID of the clicked product
 * @param {string} stlLookId - ID of the look (format: look_1, look_2, etc)
 * @param {string} stlAnchorItemId - ID of the anchor product
 * @param {string} stlPdpReferral - URL of the current PDP
 */
function pushStlCarouselClickedEvent(carouselPositionSelected, stlItemIdSelected, stlLookId, stlAnchorItemId, stlPdpReferral) {
    window.stlContext = {
        carouselPositionSelected: carouselPositionSelected,
        stlItemIdSelected: stlItemIdSelected,
        stlLookId: stlLookId,
        stlAnchorItemId: stlAnchorItemId,
        stlPdpReferral: stlPdpReferral || window.location.href
    };

    var eventData = {
        event: 'stlCarouselClicked',
        carouselPositionSelected: carouselPositionSelected,
        stlItemIdSelected: stlItemIdSelected,
        stlLookId: stlLookId,
        stlAnchorItemId: stlAnchorItemId + '',
        stlPdpReferral: stlPdpReferral || window.location.href
    };

    window.dataLayer.push(eventData);
}

/**
 * Observes an element and invokes the callback once it becomes at least `threshold` visible
 * in the viewport. Disconnects automatically after the callback fires.
 * @param {Element} element - DOM element to observe
 * @param {number} threshold - IntersectionObserver threshold (0-1)
 * @param {Function} callback - invoked once when the visibility threshold is reached
 */
function observeElementVisibility(element, threshold, callback) {
    if (!element || typeof IntersectionObserver === 'undefined') {
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
                observer.disconnect();
                callback();
            }
        });
    }, { threshold: threshold });

    observer.observe(element);
}

/**
 * Sets up Shop the Look visibility tracking.
 * Fires stlCarouselViewed once the block is at least 50% visible in the viewport.
 * @param {Element} element - the .shop-the-look block to observe
 */
function observeCarouselVisibility(element) {
    observeElementVisibility(element, 0.5, function () {
        pushStlCarouselViewedEvent();
    });
}

module.exports = {
    pushStlCarouselViewedEvent: pushStlCarouselViewedEvent,
    pushStlCarouselClickedEvent: pushStlCarouselClickedEvent,
    observeCarouselVisibility: observeCarouselVisibility
};
